import { render, staticRenderFns } from "./DriverLicenseTab.vue?vue&type=template&id=4e125671&"
import script from "./DriverLicenseTab.vue?vue&type=script&lang=js&"
export * from "./DriverLicenseTab.vue?vue&type=script&lang=js&"
import style0 from "./DriverLicenseTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports